import axios from 'axios';
import { API_RESULT_CD, CommonResult, createApiRequestUrl, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

interface ApplicationVariable {
  valueString?: string;
  valueInt?: number;
  sortOrder: number;
}

export interface ApplicationVariableInfo {
  referenceCd: string;
  referenceName: string;
  applicationVariableStringMstList: Array<ApplicationVariable>;
  applicationVariableIntMstList: Array<ApplicationVariable>;
}

export interface MasterApplicationVariableGetApiResponse {
  result: CommonResult;
  applicationVariableMstList: Array<ApplicationVariableInfo>;
}

/*
 * バックエンドからキャッシュされているアプリケーション設定情報一覧を取得
 */
export const masterApiGetAllApplicationVariableInfo = async (): Promise<MasterApplicationVariableGetApiResponse> => {
  try {
    const URL = createApiRequestUrl('master/applicationVariable');
    const response = await axios.get<MasterApplicationVariableGetApiResponse>(URL);
    const data = response.data;
    const status = response.status;

    if (status === OK.status) {
      return data;
    } else {
      throw response;
    }
  } catch (error) {
    return {
      applicationVariableMstList: [],
      result: {
        jobDateTime: '',
        resultCd: API_RESULT_CD.ERROR,
        resultMessageDtoList: [
          {
            resultMessageCd: API_RESULT_CD.ERROR,
            resultMessage: `${API_EXCEPTION_MSG}`,
          },
        ],
      },
    };
  }
};
